import { ordersService, useToast, CheckCircleOutline } from '@aslanpay/portal-common-lib';
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { OrderCompleteModalProps } from './types';

function OrderCompleteModal({ isOpen, onClose, orderId }: OrderCompleteModalProps) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleComplete = async () => {
    setIsLoading(true);
    try {
      await ordersService.completeOrder(orderId);
      await queryClient.invalidateQueries(['fetchOrdersPage']);
      toast({
        position: 'top-right',
        title: 'Invoice marked as paid',
        status: 'success',
        description: 'This invoice was marked as paid successfully.',
      });
      onClose();
    } catch (error) {
      toast({
        position: 'top-right',
        title: 'Failed to mark invoice as paid',
        status: 'error',
        description: 'An error occurred while marking this invoice as paid. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={handleClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Mark invoice as paid?</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text>Please confirm if you want to mark this invoice as paid.</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={handleClose} size="sm">
            Cancel
          </Button>
          <Button
            onClick={handleComplete}
            size="sm"
            isLoading={isLoading}
            leftIcon={<CheckCircleOutline boxSize="20px" />}
          >
            Yes, confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default OrderCompleteModal;
